import React, { useRef } from "react";
import EmptyProfilePicture from "../../../../../../../assets/blank-profile-picture.png";
import ImageNotAvailable from "../../../../../../../assets/instagram_image.png";
import { ReactComponent as EngageIcon } from "../../../../../../../assets/svg/engage-icon.svg";
import { ReactComponent as LikeIcon } from "../../../../../../../assets/svg/insta-like-icon.svg";
import { ReactComponent as YTLikeIcon } from "../../../../../../../assets/svg/yt-like-icon.svg";
import { ReactComponent as CommentIcon } from "../../../../../../../assets/svg/insta-comment-icon.svg";
import { ReactComponent as ShareIcon } from "../../../../../../../assets/svg/insta-share-icon.svg";
import { ReactComponent as ViewsIcon } from "../../../../../../../assets/svg/views.svg";
import { ReactComponent as ImpactIcon } from "../../../../../../../assets/svg/impact.svg";
import { Icon, Popup } from "semantic-ui-react";
import { kmFormatter } from "../../../../../Dashboard/Charts/utils";
import "./IgPost.scss";
import { ReactComponent as LinkedinLikeIcon } from "../../../../../../../assets/svg/Linkedin-Likes-Icon.svg";
import { ReactComponent as LinkedinCommentIcon } from "../../../../../../../assets/svg/linkedin-comments-icon.svg";
import { ReactComponent as LinkedinRepostIcon } from "../../../../../../../assets/svg/linkedin-repost-icon.svg";
import { ReactComponent as TiktokCommentsIcon } from "../../../../../../../assets/svg/tiktok-comments-icon.svg";
import { ReactComponent as TiktokShareIcon } from "../../../../../../../assets/svg/tiktok-share-icon.svg";
import { ReactComponent as YTShareIcon } from "../../../../../../../assets/svg/facebook-share-icon.svg";
import { useSelector } from "react-redux";

function IgPost(props) {
    const selectedLKPage = useSelector((state) => state.linkedinInsightsReducers.selectedLinkedinPage);
    const selectedTKPage = useSelector((state) => state.tiktokInsightsReducers.selectedTiktokPage);
    const selectedYTPage = useSelector((state) => state.youtubeInsightsReducers.selectedYoutubePage);

    let data = props?.data;

    const profileImage = useRef();
    const postImage = useRef();

    const handleProfileImageError = () => {
        profileImage.current.src = EmptyProfilePicture;
    };

    const handlePostImageError = () => {
        postImage.current.src = ImageNotAvailable;
    };

    const truncate = (str = "", max = 22) => {
        const ellipsis = str?.length > max ? "..." : "";
        return str?.slice(0, max) + ellipsis;
    };
    const getContent = (str1, str2, isLKPage) => {
        if (str1) {
            let truncStr = truncate(str1, 80);
            if (isLKPage) {
                let mentionRegex = /\[@(.*?)]/g;
                truncStr = truncStr.replace(mentionRegex, (match, username) => {
                    const mention = match.slice(2, -1);
                    return `<span style="font-weight: bold;">@${mention}</span>`;
                });

                if (truncStr.includes("[@")) {
                    truncStr = truncStr.replaceAll("[@", "@");

                    const mentionRegex = /@(\S+)/g;
                    truncStr = truncStr.replace(mentionRegex, function (match) {
                        return `<span style="font-weight: bold;">${match}</span>`;
                    });
                }

                truncStr = truncStr.replace(/@\[([^\]]+)\]/g, (match, username) => {
                    return `<span style="font-weight: bold;">@${username}</span>`;
                });
            }
            return truncStr;
        } else if (str2) return truncate(str2, 80);
        else return "";
    };
    const totalEngagementCount = () => {
        let engVal = data?.engagement?.comment_count + data?.engagement?.like_count + data?.engagement?.view_count + data?.engagement?.share_count;
        return kmFormatter(engVal);
    };

    return (
        <div className="IgPostContainer">
            <div className="header">
                <img
                    className="header_picture"
                    src={!data?.profile_pic || data?.profile_pic.includes("null") ? EmptyProfilePicture : data?.profile_pic}
                    onError={() => handleProfileImageError()}
                    ref={profileImage}
                    alt="empty"
                />
                <div className="header_name">
                    <Popup
                        className="skiptranslate"
                        position="top left"
                        size="mini"
                        inverted
                        content={
                            props.isLKPage
                                ? selectedLKPage?.page_name
                                : props.isTKPage
                                ? selectedTKPage.handler
                                : props.isYTPage
                                ? selectedYTPage?.handler
                                : data?.username
                        }
                        trigger={
                            <p className="full_name">
                                {props.isLKPage
                                    ? truncate(selectedLKPage?.page_name)
                                    : props.isTKPage
                                    ? truncate(selectedTKPage.handler)
                                    : props.isYTPage
                                    ? truncate(selectedYTPage?.handler)
                                    : truncate(data?.username)}
                            </p>
                        }
                        style={{ zIndex: "99999" }}
                    />
                    <Popup
                        trigger={<p className="user_name">{data?.created_date}</p>}
                        content={data?.hover_date}
                        inverted
                        className="skiptranslate"
                        size="mini"
                        position="top center"
                    />
                </div>
            </div>
            <div className="post">
                <div className="content" dangerouslySetInnerHTML={{ __html: getContent(data?.content, data?.title, props.isLKPage) }} />
                <div className="postImage">
                    {data?.post_type === "IMAGE" && (
                        <img
                            src={!data?.image_url || data?.image_url.includes("null") ? ImageNotAvailable : data?.image_url}
                            alt="post"
                            onError={() => handlePostImageError()}
                            ref={postImage}
                        />
                    )}
                    {data?.post_type === "VIDEO" && (
                        <>
                            <img
                                src={!data?.image_url || data?.image_url.includes("null") ? ImageNotAvailable : data?.image_url}
                                alt="post"
                                onError={() => handlePostImageError()}
                                ref={postImage}
                            />
                            <a target="_blank" href={data?.post_url} rel="noreferrer">
                                <Icon name="video play" size="huge" className="video-play" crossOrigin="" />
                            </a>
                        </>
                    )}
                </div>
            </div>

            <div className="footer">
                <Popup
                    className="twitterPopup"
                    content="Comments"
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">
                                {props.isLKPage ? <LinkedinCommentIcon /> : props.isTKPage ? <TiktokCommentsIcon /> : <CommentIcon />}
                            </div>
                            <p>{kmFormatter(data?.engagement?.comment_count)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Likes"
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">
                                {props.isLKPage ? <LinkedinLikeIcon className="linkedin__like__icon" /> : props.isYTPage ? <YTLikeIcon /> : <LikeIcon />}
                            </div>
                            <p>{kmFormatter(data?.engagement?.like_count)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />

                <Popup
                    className="twitterPopup"
                    content={props.isLKPage ? "Reposts" : "Shares"}
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">
                                {props.isLKPage ? (
                                    <LinkedinRepostIcon className="linkedin__like__icon" />
                                ) : props.isTKPage ? (
                                    <TiktokShareIcon />
                                ) : props.isYTPage ? (
                                    <YTShareIcon className="yt__share__icon" />
                                ) : (
                                    <ShareIcon />
                                )}
                            </div>

                            {/* <div className="twitterIcon">
                                <ShareIcon />
                            </div> */}
                            <p>{kmFormatter(data?.engagement?.share_count)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content={props.isLKPage ? "Impressions" : "Views"}
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">
                                <ViewsIcon />
                            </div>
                            <p>{kmFormatter(data?.engagement?.view_count)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Engagement"
                    trigger={
                        <div className="iconContainer">
                            <div className="twitterIcon">
                                <EngageIcon />
                            </div>
                            <p>{props.isTKPage || props.isYTPage ? totalEngagementCount() : kmFormatter(data?.totalEngagement)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />

                {!props.isLKPage ? (
                    <Popup
                        className="twitterPopup"
                        content="Impact Value"
                        trigger={
                            <div className="iconContainer">
                                <div className="twitterIcon">
                                    <ImpactIcon className="impact-icon" />
                                </div>
                                <p>{kmFormatter(data?.impact)}</p>
                            </div>
                        }
                        size="mini"
                        position="top left"
                        inverted
                    />
                ) : null}
                <Popup
                    className="twitterPopup"
                    content="View post"
                    trigger={
                        <div className="iconContainer twitterLinkIcon">
                            <a href={data?.post_url} target="_blank" rel="noreferrer">
                                <Icon className="twitterIcon linkIcon" name="linkify" size="mid" color="#1DA1F2" />
                            </a>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
            </div>
        </div>
    );
}

export default IgPost;
